// XP mastery bars for every process.
import { MASTERY_XP, TASK, TASK_IDS, XP } from '../config/constants';
import type { RenderResult } from './Panel';
import { $, fmt } from './panels';
import type { UI } from './UI';

export function openMasteryPanel(ui: UI): void {
  const game = ui.game;
  ui.panels.open({
    id: 'mastery',
    title: 'Mastery',
    kind: 'menu',
    side: 'center',
    render(body): RenderResult {
      body.innerHTML = `
        <div class="muted">Every process levels on its own: level = √(xp ÷ ${XP.LEVEL_DIVISOR}). Each level widens that process's timing windows by 5%. Mastery is level ${XP.MASTERY_LEVEL} (${MASTERY_XP} xp). After mastery, extra XP goes to a training bank that flows to assigned employees at ${Math.round(XP.BANK_TRANSFER_PER_DAY * 100)}% a day, and fills more slowly the fuller it gets.</div>
        <div class="stat"><span>Overall level</span><b class="overall"></b></div>
        <div class="rows"></div>`;
      const overall = $(body, '.overall');
      const rows = $(body, '.rows');
      const cells = new Map<string, { fill: HTMLElement; text: HTMLElement; right: HTMLElement }>();
      for (const t of TASK_IDS) {
        const row = document.createElement('div');
        row.className = 'mastery-row';
        const pips = Array.from({ length: XP.MASTERY_LEVEL - 1 }, (_, i) => `<span class="pip" style="left:${(((i + 1) * (i + 1)) / (XP.MASTERY_LEVEL * XP.MASTERY_LEVEL)) * 100}%"></span>`).join('');
        row.innerHTML = `<div><b>${TASK[t].label}</b><div class="muted text"></div></div><div class="mastery-bar"><div></div>${pips}</div><div class="right muted"></div>`;
        cells.set(t, { fill: $(row, '.mastery-bar > div'), text: $(row, '.text'), right: $(row, '.right') });
        rows.appendChild(row);
      }
      const update = (): void => {
        const s = game.state;
        overall.textContent = `${game.overallLevel} (${s.xp.total} xp)`;
        for (const t of TASK_IDS) {
          const c = cells.get(t);
          if (!c) continue;
          const xp = s.xp.tasks[t];
          const mastered = game.isMastered(t);
          c.fill.style.width = `${game.masteryProgress(t) * 100}%`;
          c.fill.classList.toggle('master', mastered);
          const lvl = game.taskLevel(t);
          const nextXp = XP.LEVEL_DIVISOR * (lvl + 1) * (lvl + 1);
          c.text.textContent = mastered ? 'Mastered' : `Level ${lvl} · ${xp} / ${nextXp} xp to next`;
          c.right.textContent = mastered ? `bank ${fmt(s.xp.bank[t] ?? 0, 0)} xp` : `${Math.round(game.masteryProgress(t) * 100)}% to mastery`;
        }
      };
      update();
      return { update };
    },
  });
}
